var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"widget-wrapper"},[_c('div',{staticClass:"tag"},[_vm._v("We may earn a commission")]),_vm._v(" "),_c('div',{staticClass:"widget",class:_vm.widgetSelector})])
}
var staticRenderFns = []

export { render, staticRenderFns }